<template>
  <div>
    <Header />
    <main>
      <section class="shop">
        <i class="fas fa-shield-alt"></i>
        <h1>Faq</h1>
      </section>
      <section class="faq">
        <h2>Frequently Asked Questions (FAQ)</h2>

        <div class="faq-item">
          <h3>1. Do I need to create an account to buy kits?</h3>
          <p>No, you can purchase kits directly without creating an account. It's fast, simple, and secure.</p>
        </div>

        <div class="faq-item">
          <h3>2. How do I track my order?</h3>
          <p>After your purchase, you'll receive a unique tracking code. You can check the status of your order at <a href="https://shopt2b2t.com/track" target="_blank">shopt2b2t.com/track</a>.</p>
        </div>

        <div class="faq-item">
          <h3>3. What payment methods are accepted?</h3>
          <p>We accept paypal, papara and crypto. The options will be shown during checkout.</p>
        </div>

        <div class="faq-item">
          <h3>4. I didn’t receive my kit. What should I do?</h3>
          <p>If your kit hasn’t arrived after purchase, contact us through our <a href="/contact">contact page</a> with your tracking code. We’ll sort it out quickly.</p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Header from '../Header/Header.vue'

export default {
  name: 'Faq',
  components: {
    Header
  },
  metaInfo() {
    return {
      title: "Faq | ShopT"
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
  color: #fff;
}

.faq {
  width: 100%;
  max-width: 800px;
  margin-top: 3rem;
  padding: 2rem;
  background-color: #222;
  border-radius: 10px;
  border: 2px solid #444;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.faq h2 {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #fff;
}

.faq-item {
  margin-bottom: 1.5rem;
}

.faq-item h3 {
  font-size: 1.8rem;
  color: cornflowerblue;
  margin-bottom: 0.5rem;
}

.faq-item p {
  font-size: 1.2rem;
  color: #ccc;
  line-height: 1.6;
}
.shop {
  width: 100%;
  max-width: 400px;
  margin: 3rem 0;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-bottom: 5px solid cornflowerblue;
}

.shop i {
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}

.shop h1 {
  text-transform: uppercase;
  font-size: 2.2rem;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>
